// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Abwesenheit } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useDeleteAbwesenheit(): (
  abwesenheitId: string
) => Promise<Abwesenheit> {
  const getAPI = useGetApi();
  return useCallback(
    async (abwesenheitId) =>
      (await getAPI()).abwesenheiten.deleteAbwesenheit({ abwesenheitId }),
    [getAPI]
  );
}
